function r() {
  return { before({ doc: e, d: o }) {
    o.style(e.documentElement, "overflow", "hidden");
  } };
}
export {
  r as preventScroll
};
